import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  workflowStepDependencyAll: [],
  workflowStepDependency: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const workflowStepDependencySlice = createSlice({
  name: "workflowStepDependency",
  initialState,
  reducers: {
    setWorkflowStepDependencyAll: (state, action) => {
      state.workflowStepDependencyAll = action.payload;
    },
    setWorkflowStepDependency: (state, action) => {
      state.workflowStepDependency = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setWorkflowStepDependencyAll,
  setWorkflowStepDependency,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = workflowStepDependencySlice.actions;

export default workflowStepDependencySlice.reducer;
